import { z } from 'zod';
import { order } from '@schuettflix/schema-registry-ts';

export const ProductDependencyBroadcastEventSchema =
    order.fulfillmentService.versions.v1.schemas.PRODUCT_DEPENDENCY_BROADCAST_SCHEMA;

export type ProductDependencyBroadcastEvent = z.infer<typeof ProductDependencyBroadcastEventSchema>;
